export enum TYPES_SOURCE_OPTIONS {
  SYSTEM = 'SYSTEM',
  OBJECT = 'OBJECT',
}

export enum ENTITY_COMMAND_TYPE {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  GET_ALL = 'GET_ALL',
  GET_BY_ID = 'GET_BY_ID',
  GET_BY_IDS = 'GET_BY_IDS',
  GET_ALL_BY_IDS = 'GET_ALL_BY_IDS',
  GET_BY_INTERNAL_ID = 'GET_BY_INTERNAL_ID',
  GET_ALL_BY_INTERNAL_IDS = 'GET_ALL_BY_INTERNAL_IDS',
}

export const ENTITY_GET_ALL_COMMAND_TYPES = [
  ENTITY_COMMAND_TYPE.GET_ALL,
  ENTITY_COMMAND_TYPE.GET_ALL_BY_IDS,
  ENTITY_COMMAND_TYPE.GET_ALL_BY_INTERNAL_IDS,
]

export const ON_SAVE_FORM_COMMAND_TYPES = [
  ENTITY_COMMAND_TYPE.CREATE,
  ENTITY_COMMAND_TYPE.UPDATE,
  ENTITY_COMMAND_TYPE.DELETE,
]

export enum OBJECT_COMMAND_FLAG {
  DEF_CREATE = 'def_create',
  DEF_UPDATE = 'def_update',
  DEF_DELETE_BY_ID = 'def_delete_by_id',

  DEF_READ_ALL = 'def_read_all',
  DEF_READ_BY_ID = 'def_read_by_id',
  DEF_READ_BY_IDS = 'def_read_by_ids',
  DEF_READ_BY_INTERNAL_ID = 'def_read_by_internal_id',
}

export const DEFAULT_OBJECT_FLAG_BY_ENTITY_COMMAND_TYPE: Partial<
  Record<ENTITY_COMMAND_TYPE, OBJECT_COMMAND_FLAG>
> = {
  [ENTITY_COMMAND_TYPE.CREATE]: OBJECT_COMMAND_FLAG.DEF_CREATE,
  [ENTITY_COMMAND_TYPE.UPDATE]: OBJECT_COMMAND_FLAG.DEF_UPDATE,
  [ENTITY_COMMAND_TYPE.DELETE]: OBJECT_COMMAND_FLAG.DEF_DELETE_BY_ID,

  [ENTITY_COMMAND_TYPE.GET_BY_ID]: OBJECT_COMMAND_FLAG.DEF_READ_BY_ID,
  [ENTITY_COMMAND_TYPE.GET_BY_IDS]: OBJECT_COMMAND_FLAG.DEF_READ_BY_IDS,
  [ENTITY_COMMAND_TYPE.GET_BY_INTERNAL_ID]: OBJECT_COMMAND_FLAG.DEF_READ_BY_INTERNAL_ID,

  [ENTITY_COMMAND_TYPE.GET_ALL]: OBJECT_COMMAND_FLAG.DEF_READ_ALL,
  [ENTITY_COMMAND_TYPE.GET_ALL_BY_IDS]: OBJECT_COMMAND_FLAG.DEF_READ_BY_IDS,
}

export const ENTITY_GET_BY_OBJECT_ID_COMMAND_TYPES = [
  ENTITY_COMMAND_TYPE.GET_BY_ID,
  ENTITY_COMMAND_TYPE.GET_BY_IDS,
]

export const SOURCE_SELECTION_OPTIONS = [
  {
    id: TYPES_SOURCE_OPTIONS.SYSTEM,
    label: TYPES_SOURCE_OPTIONS.SYSTEM,
  },
  {
    id: TYPES_SOURCE_OPTIONS.OBJECT,
    label: TYPES_SOURCE_OPTIONS.OBJECT,
  },
]

export const COMMAND_CACHE_TIME = 30000
